// extracted by mini-css-extract-plugin
module.exports = {"root":"title_root__2ITar","title_fnc":"title_title_fnc__1uX5h","title_zing":"title_title_zing__J5NNK"};